import { render, staticRenderFns } from "./carriage.vue?vue&type=template&id=00bfda9c&scoped=true&"
import script from "./carriage.vue?vue&type=script&lang=js&"
export * from "./carriage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bfda9c",
  null
  
)

export default component.exports